import { render, staticRenderFns } from "./EditarPaciente.vue?vue&type=template&id=2246f001"
import script from "./EditarPaciente.vue?vue&type=script&lang=js"
export * from "./EditarPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports